export const questions = [
  {
    id: 1,
    text: "When starting something new, my first move is to:",
    options: [
      { id: 'a', text: "Sketch a bold direction and what success looks like", type: "visionary" },
      { id: 'b', text: "Define the next 3 tasks and assign owners and dates", type: "executor" },
      { id: 'c', text: "Brainstorm multiple approaches and test the best one", type: "innovator" },
      { id: 'd', text: "Gather key inputs and compare likely outcomes", type: "analyst" },
      { id: 'e', text: "Choose a wedge and map the sequence of moves", type: "strategist" },
      { id: 'f', text: "Align the right people and set expectations early", type: "relationshipBuilder" }
    ]
  },
  {
    id: 2,
    text: "In a small team, I am usually the person who:",
    options: [
      { id: 'a', text: "Raises the bar with a clear vision of the future", type: "visionary" },
      { id: 'b', text: "Turns priorities into shipped outcomes", type: "executor" },
      { id: 'c', text: "Finds novel angles and creative solutions", type: "innovator" },
      { id: 'd', text: "Brings clarity with evidence and careful reasoning", type: "analyst" },
      { id: 'e', text: "Anticipates the game and picks the right battles", type: "strategist" },
      { id: 'f', text: "Builds trust and alignment across the team", type: "relationshipBuilder" }
    ]
  },
  {
    id: 3,
    text: "When a project gets messy, I usually respond by:",
    options: [
      { id: 'a', text: "Re-centering on the mission and simplifying the goal", type: "visionary" },
      { id: 'b', text: "Breaking it into steps and driving execution", type: "executor" },
      { id: 'c', text: "Trying a few experiments to find what works", type: "innovator" },
      { id: 'd', text: "Diagnosing the root cause with evidence", type: "analyst" },
      { id: 'e', text: "Reassessing positioning and the highest leverage move", type: "strategist" },
      { id: 'f', text: "Getting alignment and resolving confusion quickly", type: "relationshipBuilder" }
    ]
  },
  {
    id: 4,
    text: "In high-stakes partnerships, I prioritize:",
    options: [
      { id: 'a', text: "Shared direction and values alignment", type: "visionary" },
      { id: 'b', text: "Clear commitments and reliable delivery", type: "executor" },
      { id: 'c', text: "New ideas and experimentation together", type: "innovator" },
      { id: 'd', text: "Proof, track record, and measurable outcomes", type: "analyst" },
      { id: 'e', text: "Strategic advantage and long-term fit", type: "strategist" },
      { id: 'f', text: "Trust, communication, and relationship quality", type: "relationshipBuilder" }
    ]
  },
  {
    id: 5,
    text: "When thinking about competition, I focus on:",
    options: [
      { id: 'a', text: "Creating a category story people want to join", type: "visionary" },
      { id: 'b', text: "Out-executing with speed, quality, and consistency", type: "executor" },
      { id: 'c', text: "Staying ahead with new approaches and product bets", type: "innovator" },
      { id: 'd', text: "Using data to find weaknesses and opportunities", type: "analyst" },
      { id: 'e', text: "Positioning, distribution, and timing", type: "strategist" },
      { id: 'f', text: "Building stronger relationships and networks", type: "relationshipBuilder" }
    ]
  },
  {
    id: 6,
    text: "When making a hard decision, I trust:",
    options: [
      { id: 'a', text: "A clear vision of where the market is going", type: "visionary" },
      { id: 'b', text: "What can be executed well in the next week", type: "executor" },
      { id: 'c', text: "Trying a few options and learning fast", type: "innovator" },
      { id: 'd', text: "Data and logic over gut feelings", type: "analyst" },
      { id: 'e', text: "Second-order effects and long-term tradeoffs", type: "strategist" },
      { id: 'f', text: "Input from people I trust and respect", type: "relationshipBuilder" }
    ]
  },
  {
    id: 7,
    text: "My biggest value to the team is:",
    options: [
      { id: 'a', text: "Direction and purpose when things feel uncertain", type: "visionary" },
      { id: 'b', text: "Getting the work done with high reliability", type: "executor" },
      { id: 'c', text: "Creative options when the obvious path fails", type: "innovator" },
      { id: 'd', text: "Clarity and truth through analysis", type: "analyst" },
      { id: 'e', text: "Choosing the right priorities and sequencing", type: "strategist" },
      { id: 'f', text: "Trust, communication, and healthy conflict", type: "relationshipBuilder" }
    ]
  },
  {
    id: 8,
    text: "My default approach to risk is:",
    options: [
      { id: 'a', text: "Take bold bets if the upside changes the game", type: "visionary" },
      { id: 'b', text: "Take risks only with a clear plan and owner", type: "executor" },
      { id: 'c', text: "Run small experiments and iterate", type: "innovator" },
      { id: 'd', text: "Reduce risk with analysis and verification", type: "analyst" },
      { id: 'e', text: "Time risks strategically for maximum leverage", type: "strategist" },
      { id: 'f', text: "Get input to reduce blind spots and build buy-in", type: "relationshipBuilder" }
    ]
  },
  {
    id: 9,
    text: "I feel most energized when I am:",
    options: [
      { id: 'a', text: "Imagining a future that feels worth building", type: "visionary" },
      { id: 'b', text: "Shipping and seeing progress quickly", type: "executor" },
      { id: 'c', text: "Exploring ideas and creating something new", type: "innovator" },
      { id: 'd', text: "Finding patterns and extracting insight", type: "analyst" },
      { id: 'e', text: "Designing a strategy and playing the long game", type: "strategist" },
      { id: 'f', text: "Building relationships and alignment", type: "relationshipBuilder" }
    ]
  },
  {
    id: 10,
    text: "When planning for the next 90 days, I prefer to:",
    options: [
      { id: 'a', text: "Anchor to the vision and let tactics adapt", type: "visionary" },
      { id: 'b', text: "Define milestones and ship weekly", type: "executor" },
      { id: 'c', text: "Keep room for experiments and pivots", type: "innovator" },
      { id: 'd', text: "Base the plan on research and signals", type: "analyst" },
      { id: 'e', text: "Pick a wedge and sequence moves deliberately", type: "strategist" },
      { id: 'f', text: "Make sure people are aligned and committed", type: "relationshipBuilder" }
    ]
  },
  {
    id: 11,
    text: "My communication style is usually:",
    options: [
      { id: 'a', text: "Inspiring and future-focused", type: "visionary" },
      { id: 'b', text: "Direct, practical, and action-oriented", type: "executor" },
      { id: 'c', text: "Creative and idea-rich", type: "innovator" },
      { id: 'd', text: "Logical, precise, and evidence-based", type: "analyst" },
      { id: 'e', text: "Strategic, framing tradeoffs and scenarios", type: "strategist" },
      { id: 'f', text: "Empathetic, aiming for alignment and trust", type: "relationshipBuilder" }
    ]
  },
  {
    id: 12,
    text: "I do my best work in an environment that is:",
    options: [
      { id: 'a', text: "Big on ambition and direction", type: "visionary" },
      { id: 'b', text: "Clear on goals, roles, and execution", type: "executor" },
      { id: 'c', text: "Open to creative exploration and testing", type: "innovator" },
      { id: 'd', text: "Driven by metrics and learning loops", type: "analyst" },
      { id: 'e', text: "Focused on strategy and long-term leverage", type: "strategist" },
      { id: 'f', text: "High trust with strong collaboration", type: "relationshipBuilder" }
    ]
  },
  {
    id: 13,
    text: "When solving a problem, I am best at:",
    options: [
      { id: 'a', text: "Seeing the bigger meaning and direction", type: "visionary" },
      { id: 'b', text: "Turning ideas into practical steps quickly", type: "executor" },
      { id: 'c', text: "Generating novel solutions and approaches", type: "innovator" },
      { id: 'd', text: "Finding patterns and testing hypotheses", type: "analyst" },
      { id: 'e', text: "Choosing the right problem and leverage point", type: "strategist" },
      { id: 'f', text: "Aligning stakeholders and building support", type: "relationshipBuilder" }
    ]
  },
  {
    id: 14,
    text: "When thinking about growth, I tend to prioritize:",
    options: [
      { id: 'a', text: "Big, bold moves that change the narrative", type: "visionary" },
      { id: 'b', text: "Consistent execution and operational leverage", type: "executor" },
      { id: 'c', text: "New products, experiments, and creative disruption", type: "innovator" },
      { id: 'd', text: "Measuring, optimizing, and scaling what works", type: "analyst" },
      { id: 'e', text: "Positioning and strategic advantage", type: "strategist" },
      { id: 'f', text: "Partnerships, relationships, and distribution", type: "relationshipBuilder" }
    ]
  },
  {
    id: 15,
    text: "When under real pressure, I default to:",
    options: [
      { id: 'a', text: "Reframing the mission and raising ambition", type: "visionary" },
      { id: 'b', text: "Driving execution and pushing to ship", type: "executor" },
      { id: 'c', text: "Trying new angles and iterating rapidly", type: "innovator" },
      { id: 'd', text: "Seeking more information and reducing uncertainty", type: "analyst" },
      { id: 'e', text: "Re-evaluating strategy and changing the plan", type: "strategist" },
      { id: 'f', text: "Protecting relationships and keeping the team aligned", type: "relationshipBuilder" }
    ]
  }
];